import SaveIcon from '@mui/icons-material/Save';
import {
    useAppSidePanelContextProvider
} from "../../../shared/contexts/app-side-panel-context-provider/components/AppSidePanelContextProvider";
import { ToolsPanelButton } from "./ToolsPanelButton";

type SavePortfolioProps = {
    isPortfolioChanged: boolean;
    setIsPortfolioChanged: React.Dispatch<React.SetStateAction<boolean>>;
};

export function SavePortfolioButton({
  isPortfolioChanged,
  setIsPortfolioChanged
}: SavePortfolioProps){
    const {
        saveSelectedPortfolio,
    } = useAppSidePanelContextProvider();
    
    const handleSavePortfolio = async (): Promise<void> => {
        await saveSelectedPortfolio();
        setIsPortfolioChanged(false);
    };
    
    return (
        <ToolsPanelButton
            tooltipText="Save the portfolio"
            disabled={!isPortfolioChanged}
            onChanged={handleSavePortfolio}
        >
            <SaveIcon sx={{
                height: '18px',
                width: '18px',
            }} />
        </ToolsPanelButton>
    );
}